/**
 * @fileoverview TourPlans.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import TopImageBanner from '../components/tours/TopImageBanner';
import TourDisplayArea from '../components/tours/TourDisplayArea';
import SEO from '../components/ui/SEO'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function TourPlans() {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col w-full min-h-screen pt-24 md:pt-32'>
        <SEO 
            title="Tour Plans" 
            description="Browse curated Sri Lanka tour plans designed by local experts. From adventure cycling and cultural heritage journeys to beach retreats and wildlife safaris, find the holiday package that suits your travel style and budget."
            keywords="Sri Lanka tour packages, Sri Lanka holiday plans, adventure tours Sri Lanka, cultural tours Sri Lanka, beach holidays Sri Lanka, wildlife safari packages, custom itinerary Sri Lanka"
        />
        {/* Hero Section */}
        <div className='px-[5%] md:px-[10%]'>
            <div className='relative w-full h-[50vh] md:h-[60vh]'>
                <TopImageBanner title={t('tour_plans.hero_title')} />
            </div>
        </div>

        <div className='flex flex-col w-full gap-12 px-[5%] md:px-[10%] py-16 justify-start items-center overflow-hidden'>
            {/* Create Your Tour Section */}
            <div className='flex flex-col items-center text-center gap-4 max-w-2xl'>
                <h2 className='text-3xl md:text-4xl font-bold text-KITH-primary'>{t('tour_plans.create_title')}</h2>
                <p className='text-gray-600 text-sm md:text-base leading-relaxed'>
                    {t('tour_plans.create_desc')}
                </p>
                <Link to="/custom-tour" className='mt-2 bg-KITH-primary text-white px-8 py-3 rounded-full hover:shadow-lg font-medium transition-all inline-flex items-center gap-2 w-max'>
                    {t('tour_plans.start_planning')} <span className='text-xl'>→</span>
                </Link>
            </div>

            {/* Tours Display Section */}
            <TourDisplayArea />
        </div>
    </div>
  )
}

export default TourPlans